import { MenuItem } from "@mui/material";
import React from "react";
import useWiviContent from "Utils/hooks/wiviContent";

const ParentMenuItem = ({ value, p, ...props }) => {
  const { title } = useWiviContent({
    ...p,
    id: p?.target?.id,
    type: p?.target?.type,
  });

  return (
    <MenuItem
      value={value}
      sx={{ overflow: "hidden", textOverflow: "ellipsis" }}
      {...props}
    >
      {title}
    </MenuItem>
  );
};

export default ParentMenuItem; 